// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"664428e8","171":"15fcbc46","432":"4a31eb44","994":"25029653"}[chunkId] + ".chunk.js";
};